import { Text } from "@/components/atoms/Text/Text";
import { Skeleton } from "@/components/atoms/Skeleton/Skeleton";
import { Dialog } from "@/components/molecules/Dialog/Dialog";
import {
  type SkillPackageSource,
  useSkillFileViewer,
} from "./useSkillFileViewer";

interface Props {
  source: SkillPackageSource;
  path: string | null;
  onClose: () => void;
}

export function SkillFileViewer({ source, path, onClose }: Props) {
  const { content, isLoading, unavailable } = useSkillFileViewer({
    source,
    path,
  });

  return (
    <Dialog
      title={<span className="font-mono text-body break-all">{path}</span>}
      styling={{ width: "760px" }}
      controlled={{
        isOpen: path !== null,
        set: (open) => {
          if (!open) onClose();
        },
      }}
    data-sentry-element="Dialog" data-sentry-component="SkillFileViewer" data-sentry-source-file="SkillFileViewer.tsx">
      <Dialog.Content data-sentry-element="Dialog.Content" data-sentry-source-file="SkillFileViewer.tsx">
        <div data-testid="skill-file-viewer">
          {isLoading ? (
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <Skeleton className="h-4 w-2/3" />
            </div>
          ) : unavailable ? (
            <Text variant="body-tight" tone="muted">
              {unavailable}
            </Text>
          ) : (
            <pre className="max-h-[60vh] overflow-auto rounded-md bg-surface-muted p-3 font-mono text-body-sm leading-5 text-foreground-body">
              {content}
            </pre>
          )}
        </div>
      </Dialog.Content>
    </Dialog>
  );
}
